module.exports = __webpack_public_path__ + "media/images/new/trail_maps_laptop@2x-cda28c01ff764632c5d3fdf896c45a52.png";